import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { IProviderServiceState, initialProviderServiceState } from "./provider-service.state";
import { ProviderService } from "../../models/provider/provider-service.model";

export const withProviderServiceStateMethods = signalStoreFeature(
    { state: type<IProviderServiceState>() },
    withMethods((store) => ({
        setProviderServices: (providerServices: ProviderService[]) => {
            patchState(store, { providerServices, loading: false, error: null });
        },
        setCurrentProviderService: (providerService: ProviderService) => {
            patchState(store, { currentProviderService: providerService, loading: false, error: null });
        },
        addProviderService: (providerService: ProviderService) => {
            patchState(store, {
                providerServices: [...store.providerServices(), providerService],
                saving: false,
                error: null
            });
        },
        replaceProviderService: (providerService: ProviderService) => {
            patchState(store, {
                providerServices: store.providerServices().map(s =>
                    s.providerServiceGuid === providerService.providerServiceGuid ? providerService : s
                ),
                saving: false,
                error: null
            });
        },
        removeProviderService: (providerServiceGuid: string) => {
            patchState(store, {
                providerServices: store.providerServices().filter(s => s.providerServiceGuid !== providerServiceGuid),
                deleting: false,
                error: null
            });
        },
        setError: (error: string) => {
            patchState(store, { error, loading: false, saving: false, deleting: false });
        },
        clearProviderService: () => {
            patchState(store, initialProviderServiceState);
        }
    }))
);
